const PAGE_SIZE = 15;

class MonogramStyles extends HTMLElement {
  connectedCallback() {
    this.results = this.querySelector("[data-results]");

    if (!this.results) return;

    this.viewMore = this.querySelector("[data-view-more]");
    this.viewMoreButton = this.querySelector("[data-view-more-button]");
    this.filters = [...this.querySelectorAll("[data-filter]")];
    this.active =
      this.filters.find(
        (filter) => filter.getAttribute("aria-pressed") === "true",
      ) || null;

    this.onFilterClick = (event) => this.select(event.currentTarget);
    this.onViewMoreClick = () => this.reveal();
    // Grid sections can be added, removed or edited in the theme editor.
    this.onSectionChange = () => this.render();

    this.filters.forEach((filter) =>
      filter.addEventListener("click", this.onFilterClick),
    );
    this.viewMoreButton?.addEventListener("click", this.onViewMoreClick);
    document.addEventListener("shopify:section:load", this.onSectionChange);
    document.addEventListener("shopify:section:unload", this.onSectionChange);

    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener("shopify:section:load", this.onSectionChange);
    document.removeEventListener(
      "shopify:section:unload",
      this.onSectionChange,
    );
  }

  select(filter) {
    this.active = filter;
    this.filters.forEach((button) =>
      button.setAttribute("aria-pressed", String(button === filter)),
    );

    this.render();
  }

  /** Rebuilds the grid from the source sections, back on the first page. */
  render() {
    this.items = this._sources().flatMap((grid) => [
      ...grid.querySelectorAll("[data-monogram-item]"),
    ]);
    this.visible = 0;

    this.results.replaceChildren();
    this.reveal();
  }

  reveal() {
    const next = Math.min(this.visible + PAGE_SIZE, this.items.length);

    this.results.append(
      ...this.items
        .slice(this.visible, next)
        .map((item) => item.cloneNode(true)),
    );
    this.visible = next;

    this.results.classList.toggle("hidden", next === 0);
    this.viewMore?.classList.toggle("hidden", next >= this.items.length);
  }

  /**
   * The grids the active filter draws from: the ones whose label it matches,
   * or — when it matches none, the "All" case — every grid on the page in
   * Unfiltered order.
   */
  _sources() {
    const label = this.active?.dataset.filter;
    const grids = this._grids();
    const matches = label
      ? grids.filter((grid) => grid.dataset.label === label)
      : [];

    if (matches.length) return matches;

    // Sorting is stable, so grids sharing an order keep their page order.
    return grids.sort((a, b) => this._order(a) - this._order(b));
  }

  _grids() {
    return [...document.querySelectorAll("[data-monogram-grid]")];
  }

  _order(grid) {
    return parseFloat(grid.dataset.order) || 0;
  }
}

if (!customElements.get("monogram-styles")) {
  customElements.define("monogram-styles", MonogramStyles);
}
